module.exports = "/_next/static/images/PredictiveAIModels@2x-25380b4bb8eefff295c14ba8176e8cd7.webp";